import t from '@jetshop/intl';
import React, { useState } from 'react';
import { styled } from 'linaria/react';
import useGeolocation from '@jetshop/core/hooks/useGeolocation';

import TrendButton from '../ui/Button';
import { ReactComponent as MapMarker } from '../../svg/MapPinFull.svg';

import { theme } from '../Theme';

const LocationButton = styled(TrendButton)`
  &.locBtn.locBtn.locBtn {
    margin: 0 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.5rem !important;
    width: auto;
    color: #fff;
    white-space: nowrap;
    background: #235837 !important;
    border: none;
    svg {
      position: static;
      height: auto;
      width: 20px;
    }
    ${theme.below.lg} {
      margin: 1rem 0 0;
      width: 100%;
    }
  }
`;

const UserLocation = ({ setUserLocation, setSelectedStore }) => {
  const [loading, setLoading] = useState(false);
  const { getPosition, isAvailable } = useGeolocation({
    onSuccess: ({ coords: { latitude, longitude } }) => {
      setUserLocation({ latitude, longitude });
      setSelectedStore(null);
      setLoading(false);
    },
    onError: err => console.log(err)
  });
  if (!isAvailable) return null;
  const triggerPosition = () => {
    getPosition();
    setLoading(true);
  };
  return (
    <LocationButton className="locBtn" onClick={triggerPosition}>
      <MapMarker />
      {!loading ? t('Find my closest store') : t('Finding your closest store')}
    </LocationButton>
  );
};

export default UserLocation;
